<template>
  <App>
    <AppBar>
        <AppTitle icon="xiangmu2" name="知识库" />
       
        <div>{{ toolBarValue }}</div>
    </AppBar>
    <AppClient class="flex-wrap align-stretch">
      <div class="flex-col align-stretch" style="flex-shrink:0;width:300px;flex-grow:1;">
        <Toolbar :items="directoryTools" v-model="toolBarValue"  @on-event="handleDirectoryToolbarEvent" style="flex-shrink:0;border-bottom:1px solid var(--border);width:100%;"/>
        <KnowledgeDirectory
          :dirs="directories"
          :selected-dir="selectedDir"
          style="flex-grow:1"
          @on-select="handleDirSelect"
          @on-drop-in="handleDirDropIn"
          @on-drop-file="handleFileDropToDir"
        ></KnowledgeDirectory>
      </div>
       
        <div class="flex-col align-stretch" style="flex-grow:1;width:calc(100% - 300px);">
          <Toolbar :items="dataTools" v-model="toolBarValue"  @on-event="handleDataToolbarEvent" @input="handleToolbarInput" style="flex-shrink:0;border-bottom:1px solid var(--border);width:100%;"/>
          <KnowledgeList
          style="flex-grow:1"
          :loading="loading"
          :items="filteredItems"
          :all-items="allItems"
          :view-mode="viewMode"
          @on-drop-in-folder="handleItemDropInFolder"
          @on-select="handleItemSelect"
          @on-open="handleItemOpen"
          @on-edit="handleItemEdit"
          @on-file-drop="handleFileDrop"
        ></KnowledgeList>
        </div>

        <Drawer v-model="showDetail" :width="800" :styles="{
          padding:0
        }">
          <KnowledgeDetail :current="current" :all-items="allItems" />
        </Drawer>

        <!-- 目录编辑对话框 -->
        <Modal v-model="showDirEditor" :title="dirEditorTitle" footer-hide :mask-closable="false">
          <div class="knowledge-modal-content">
            <Form :model="dirForm" :label-width="100">
              <FormItem label="目录类型">
                <RadioGroup v-model="dirForm.type" class="dir-type-selector">
                  <Radio label="dir" class="dir-type-option">
                    <BaseIcon icon="md-folder" :size="20" style="margin-right:5px;" />
                    <span>目录</span>
                  </Radio>
                  <Radio label="link-dir" class="dir-type-option">
                    <BaseIcon icon="lianjie" :size="20" style="margin-right:5px;" />
                    <span>引用目录</span>
                  </Radio>
                </RadioGroup>
              </FormItem>
              <FormItem label="目录名称">
                <Input v-model="dirForm.name" placeholder="请输入目录名称" size="large" :maxlength="50" />
              </FormItem>
              <FormItem label="描述">
                <Input 
                  v-model="dirForm.description" 
                  type="textarea" 
                  :rows="3" 
                  placeholder="请输入目录描述（最多128字）" 
                  size="large"
                  :maxlength="128"
                  show-word-limit
                />
              </FormItem>
              <FormItem label="远程API" v-if="dirForm.type === 'link-dir'">
                <Input v-model="dirForm.remote_api" placeholder="请输入远程API地址" size="large" />
              </FormItem>
            </Form>
          </div>
          <div class="knowledge-modal-footer">
            <Button @click="handleDirCancel" size="large">取消</Button>
            <Button type="primary" @click="handleDirSubmit" size="large" style="margin-left:10px;">确定</Button>
          </div>
        </Modal>

        <!-- 内容编辑对话框 -->
        <Modal v-model="showItemEditor" :title="itemEditorTitle" :width="1000" footer-hide :mask-closable="false">
          <div class="knowledge-modal-content">
            <Form :model="itemForm" :label-width="100">
              <FormItem label="标题">
                <Input v-model="itemForm.name" placeholder="请输入标题" size="large" :maxlength="100" />
              </FormItem>
              <FormItem label="内容类型">
                <div class="type-selector">
                  <div
                    v-for="typeOption in typeOptions"
                    :key="typeOption.value"
                    class="type-option"
                    :class="{ 'active': itemForm.type === typeOption.value }"
                    @click="itemForm.type = typeOption.value; handleItemTypeChange()"
                  >
                    <BaseIcon :icon="typeOption.icon" :size="24" />
                    <span>{{ typeOption.label }}</span>
                  </div>
                </div>
              </FormItem>
              <FormItem label="所属目录">
                <Select v-model="itemForm.dir_id" clearable size="large" style="width:300px;">
                  <Option :value="null">无</Option>
                  <Option v-for="dir in allDirectories" :key="dir.id" :value="dir.id">{{ dir.name }}</Option>
                </Select>
              </FormItem>
              
              <!-- 文件类型 -->
              <FormItem label="文件上传" v-if="itemForm.type === 'file'">
                <Upload
                  :before-upload="handleFileUpload"
                  action=""
                >
                  <Button icon="ios-cloud-upload-outline" size="large">选择文件</Button>
                </Upload>
                <div v-if="itemForm.content" style="margin-top:10px;padding:10px;background:var(--bg3);border-radius:4px;">
                  <BaseIcon icon="wenjian" :size="18" style="margin-right:5px;" />
                  <a :href="itemForm.content" target="_blank">{{ itemForm.content }}</a>
                </div>
              </FormItem>

              <!-- 文本类型 -->
              <FormItem label="文本内容" v-if="itemForm.type === 'text'">
                <Input v-model="itemForm.content" type="textarea" :rows="12" placeholder="请输入文本内容" />
              </FormItem>

              <!-- Markdown类型 -->
              <FormItem label="Markdown内容" v-if="itemForm.type === 'md'">
                <div class="markdown-editor-wrapper">
                  <MarkdownEditor v-model="itemForm.content" />
                </div>
              </FormItem>

              <!-- HTML类型 -->
              <FormItem label="HTML内容" v-if="itemForm.type === 'html'">
                <div class="html-editor-wrapper">
                  <TextEditor v-model="itemForm.content" />
                </div>
              </FormItem>
            </Form>
          </div>
          <div class="knowledge-modal-footer">
            <Button @click="handleItemCancel" size="large">取消</Button>
            <Button type="primary" @click="handleItemSubmit" size="large" style="margin-left:10px;">确定</Button>
          </div>
        </Modal>
        
    </AppClient>
  </App>
</template>

<script>
import App from '@/components/app/app'
import AppBar from '@/components/app/bar'
import AppTitle from '@/components/app/title'
import AppClient from '@/components/app/client'
import KnowledgeDirectory from '@/components/knowledge/directory'
import KnowledgeList from '@/components/knowledge/list'
import KnowledgeDetail from '@/components/knowledge/detail'
import Toolbar from '@/components/app/toolbar'
import MarkdownEditor from '@/components/base/MarkdownEditor'
import TextEditor from '@/components/base/TextEditor'
import BaseIcon from '@/components/base/Icon'
import UTIL from '@/utils'

export default {   
    data(){
      return {
        directories:[],
        items:[],
        allItems:[],
        loading:false,
        showDetail:false,
        current:null,
        selectedDir:null,
        selectedItems:[],
        searchText:'',
        toolBarValue:{
          dashboard:true,
          view_mode:'icon'
        },
        showDirEditor:false,
        dirForm:{
          name:'',
          type:'dir',
          remote_api:'',
          description:''
        },
        showItemEditor:false,
        itemForm:{
          type:'text',
          content:'',
          dir_id:null
        }
      }
    },
    components:{App,AppBar,AppTitle,AppClient,KnowledgeDirectory,KnowledgeList,Toolbar,KnowledgeDetail,MarkdownEditor,TextEditor,BaseIcon},
    computed:{
      viewMode(){
        if(this.toolBarValue){
          return this.toolBarValue.view_mode
        }
        return 'icon'
      },
      filteredItems(){
        let items = this.allItems
        // 按目录过滤
        if(this.selectedDir){
          items = items.filter(item => item.dir_id === this.selectedDir.id)
        }
        // 按搜索文本过滤
        if(this.searchText){
          const search = this.searchText.toLowerCase()
          items = items.filter(item => {
            const content = (item.content || '').toLowerCase()
            return content.includes(search)
          })
        }
        return items
      },
      allDirectories(){
        return UTIL.plat(this.directories, {LIST_KEY: 'subs'}) || []
      },
      availableDirectories(){
        return this.allDirectories.filter(dir => dir.id !== this.dirForm.id)
      },
      typeOptions(){
        return [
          { value: 'file', label: '文件', icon: 'wenjian' },
          { value: 'text', label: '文本', icon: 'md-document' },
          { value: 'md', label: 'Markdown', icon: 'codelibrary-fill' },
          { value: 'html', label: 'HTML', icon: 'css' },
        ]
      },
      directoryTools(){
        const hasSelected = !!this.selectedDir
        const isSystem = hasSelected && this.selectedDir.type === 'system'
        const editBtns = [{
          type:"icon-button",
          icon:'md-create',
          name:'编辑',
          key:'edit',
          disabled:!hasSelected || isSystem
        },{
          type:"icon-button",
          icon:'md-trash',
          name:'删除',
          key:'remove',
          disabled:!hasSelected || isSystem
        }]

        return [{
          type:"icon-button",
          icon:'md-add',
          name:'新增',
          key:'add',
        },
        ...editBtns,
        ]
      },
      dataTools(){
        const hasSelected = this.selectedItems.length > 0
        const canEdit = this.selectedItems.length === 1
        const canMirror = this.selectedItems.length > 0 && this.selectedItems.every(item => item.type !== 'ref')
        const editBtns = [{
          type:"icon-button",
          icon:'md-create',
          name:'编辑',
          key:'edit',
          disabled:!canEdit
        },{
          type:"icon-button",
          icon:'md-copy',
          name:'镜像',
          key:'mirror',
          disabled:!canMirror
        },{
          type:"icon-button",
          icon:'md-trash',
          name:'删除',
          key:'remove',
          disabled:!hasSelected
        }]

        return [{
          type:"icon-button",
          icon:'md-add',
          name:'新增',
          key:'add',
        },
        ...editBtns,
        {
          type:'divider',
        },
        {
          type:'tabs',
          key:'view_mode',
          subs:[{
          type:"icon-button",
          icon:'md-speedometer',
          name:'图标',
          togglable:true,
          key:'icon',
        },{
          type:"icon-button",
          icon:'pm2',
          name:'列表',
          togglable:true,
          key:'list',
        },{
          type:"icon-button",
          icon:'pm2',
          name:'大纲',
          togglable:true,
          key:'brief',
        }]
        }]
      },
      dirEditorTitle(){
        return this.dirForm.id ? '编辑目录' : '新建目录'
      },
      itemEditorTitle(){
        return this.itemForm.id ? '编辑内容' : '新建内容'
      }
    },
    mounted(){
      this.loading = true
      this.$api.afterLogin(()=>{
        this.fetchDirectories()
        this.fetchItems()
      })
    },
    methods:{
      fetchDirectories(){
        this.loading = true
        this.$api.get('/knowledge/directories').then(res=>{
          this.directories = res.data.data || []
          this.loading = false
        }).catch(err=>{
          this.$Message.error('获取目录列表失败: ' + err)
          this.loading = false
        })
      },
      fetchItems(){
        this.loading = true
        this.$api.get('/knowledge/data').then(res=>{
          this.allItems = res.data.data || []
          this.items = this.allItems
          this.loading = false
        }).catch(err=>{
          this.$Message.error('获取内容列表失败: ' + err)
          this.loading = false
        })
      },
      handleDirSelect(dir){
        this.selectedDir = dir
        this.selectedItems = []
      },
      handleItemSelect(items){
        this.selectedItems = items
      },
      handleDirDropIn(data){
        const {draggedId, targetDirId} = data
        // 检查是否是目录（在directories中能找到）
        const isDirectory = this.allDirectories.some(dir => dir.id === draggedId)
        if(isDirectory){
          // 目录拖拽，移动目录
          this.$api.put(`/knowledge/directories/${draggedId}`, {
            parent_id: targetDirId
          }).then(()=>{
            this.$Message.success('移动成功')
            this.fetchDirectories()
          }).catch(err=>{
            this.$Message.error('移动失败: ' + err)
          })
        }
        // 如果是文件，会在handleFileDropToDir中处理
      },
      handleFileDropToDir(data){
        const {draggedId, targetDirId} = data
        // 检查是否是文件（在items中能找到，且不是目录）
        const draggedItem = this.allItems.find(item => item.id === draggedId)
        if(draggedItem){
          // 文件拖拽到目录，使用PATCH修改dir_id
          this.$api.patch(`/knowledge/data/${draggedId}`, {
            dir_id: targetDirId
          }).then(()=>{
            this.$Message.success('移动成功')
            // 如果当前选中的目录就是目标目录，则刷新列表；否则从列表中移除该文件
            if(this.selectedDir && this.selectedDir.id === targetDirId){
              this.fetchItems()
            } else {
              // 从当前列表中移除该文件（本地更新）
              this.items = this.items.filter(item => item.id !== draggedId)
              this.allItems = this.allItems.map(item => {
                if(item.id === draggedId){
                  return {...item, dir_id: targetDirId}
                }
                return item
              })
            }
          }).catch(err=>{
            this.$Message.error('移动失败: ' + err)
          })
        }
      },
      handleItemDropInFolder(data){
        const {draggedId, targetItemId} = data
        const targetItem = this.allItems.find(item => item.id === targetItemId)
        if(!targetItem || !targetItem.dir_id){
          this.$Message.warning('无法移动到该位置')
          return
        }
        this.$api.put(`/knowledge/data/${draggedId}`, {
          dir_id: targetItem.dir_id
        }).then(()=>{
          this.$Message.success('移动成功')
          this.fetchItems()
        }).catch(err=>{
          this.$Message.error('移动失败: ' + err)
        })
      },
      handleDirectoryToolbarEvent(e){
        const {key} = e
        if(key === 'add'){
          this.dirForm = {
            name:'',
            type:'dir',
            parent_id:this.selectedDir ? this.selectedDir.id : null,
            remote_api:'',
            description:''
          }
          this.showDirEditor = true
        }else if(key === 'edit'){
          if(!this.selectedDir) return
          // 系统目录不可编辑
          if(this.selectedDir.type === 'system'){
            this.$Message.warning('系统目录不可编辑')
            return
          }
          this.dirForm = {
            id:this.selectedDir.id,
            name:this.selectedDir.name,
            type:this.selectedDir.type,
            parent_id:this.selectedDir.parent_id,
            remote_api:this.selectedDir.remote_api || '',
            description:this.selectedDir.description || ''
          }
          this.showDirEditor = true
        }else if(key === 'remove'){
          if(!this.selectedDir) return
          // 系统目录不可删除
          if(this.selectedDir.type === 'system'){
            this.$Message.warning('系统目录不可删除')
            return
          }
          this.$Modal.confirm({
            title:'确认删除',
            content:`确定要删除目录"${this.selectedDir.name}"吗？`,
            onOk:()=>{
              this.$api.delete(`/knowledge/directories/${this.selectedDir.id}`).then(()=>{
                this.$Message.success('删除成功')
                this.selectedDir = null
                this.fetchDirectories()
              }).catch(err=>{
                this.$Message.error('删除失败: ' + err)
              })
            }
          })
        }
      },
      handleDataToolbarEvent(e){
        const {key,type,value} = e
        if(key === 'add'){
          this.itemForm = {
            type:'text',
            content:'',
            dir_id:this.selectedDir ? this.selectedDir.id : null,
            name:''
          }
          this.showItemEditor = true
        }else if(key === 'edit'){
          if(this.selectedItems.length !== 1) return
          const item = this.selectedItems[0]
          this.itemForm = {
            id:item.id,
            type:item.type,
            content:item.content || '',
            dir_id:item.dir_id,
            name:item.name || ''
          }
          this.showItemEditor = true
        }else if(key === 'remove'){
          if(this.selectedItems.length === 0) return
          this.$Modal.confirm({
            title:'确认删除',
            content:`确定要删除选中的${this.selectedItems.length}个项目吗？`,
            onOk:()=>{
              const promises = this.selectedItems.map(item => 
                this.$api.delete(`/knowledge/data/${item.id}`)
              )
              Promise.all(promises).then(()=>{
                this.$Message.success('删除成功')
                this.selectedItems = []
                this.fetchItems()
              }).catch(err=>{
                this.$Message.error('删除失败: ' + err)
              })
            }
          })
        }else if(type == 'tab-change'){
          this.toolBarValue.toolBarValue.view_mode = value
        }else if(key === 'mirror'){
          if(this.selectedItems.length === 0) return
          // 检查是否都是引用类型，引用类型不能镜像
          if(this.selectedItems.some(item => item.ref)){
            this.$Message.warning('引用类型不能创建镜像')
            return
          }
          // 直接在当前选中的目录创建镜像，如果没有选中目录则使用原文件的目录
          const targetDirId = this.selectedDir ? this.selectedDir.id : (this.selectedItems[0] ? this.selectedItems[0].dir_id : null)
          
          if(!targetDirId){
            this.$Message.warning('请先选择目录')
            return
          }
          
          // 为每个选中的项目创建引用数据，保持原类型和名称，设置ref为true
          const promises = this.selectedItems.map(item => {
            // 获取源文件（如果是引用文件，需要找到真正的源文件）
            const sourceItem = item.ref && item.content ? this.allItems.find(i => i.id === item.content) : item
            return this.$api.post('/knowledge/data', {
              type: sourceItem.type, // 保持原类型
              content: sourceItem.id, // 引用原始内容的ID
              dir_id: targetDirId,
              ref: true // 标记为引用
            })
          })
          
          Promise.all(promises).then(()=>{
            this.$Message.success(`成功创建 ${this.selectedItems.length} 个镜像`)
            this.fetchItems()
          }).catch(err=>{
            this.$Message.error('创建镜像失败: ' + err)
          })
        }
      },
      handleDirSubmit(){
        if(!this.dirForm.name){
          this.$Message.warning('请输入目录名称')
          return
        }
        const url = this.dirForm.id 
          ? `/knowledge/directories/${this.dirForm.id}`
          : '/knowledge/directories'
        const method = this.dirForm.id ? 'put' : 'post'
        
        this.$api[method](url, this.dirForm).then(()=>{
          this.$Message.success('保存成功')
          this.showDirEditor = false
          this.fetchDirectories()
        }).catch(err=>{
          this.$Message.error('保存失败: ' + err)
        })
      },
      handleDirCancel(){
        this.showDirEditor = false
        this.dirForm = {
          name:'',
          type:'dir',
          parent_id:null,
          remote_api:'',
          description:''
        }
      },
      handleItemSubmit(){
        if(!this.itemForm.type){
          this.$Message.warning('请选择类型')
          return
        }
        if(this.itemForm.type === 'file' && !this.itemForm.content){
          this.$Message.warning('请上传文件')
          return
        }
        if(this.itemForm.type !== 'file' && !this.itemForm.content){
          this.$Message.warning('请输入内容')
          return
        }
        const url = this.itemForm.id 
          ? `/knowledge/data/${this.itemForm.id}`
          : '/knowledge/data'
        const method = this.itemForm.id ? 'put' : 'post'
        
        this.$api[method](url, this.itemForm).then(()=>{
          this.$Message.success('保存成功')
          this.showItemEditor = false
          this.fetchItems()
        }).catch(err=>{
          this.$Message.error('保存失败: ' + err)
        })
      },
      handleItemCancel(){
        this.showItemEditor = false
        this.itemForm = {
          type:'text',
          content:'',
          dir_id:null,
          name:''
        }
      },
      handleItemTypeChange(){
        this.itemForm.content = ''
      },
      handleFileUpload(file){
        // 自动获取文件名称
        const fileName = file.name || ''
        if(!this.itemForm.name && fileName){
          // 去掉扩展名作为默认名称
          const nameWithoutExt = fileName.substring(0, fileName.lastIndexOf('.')) || fileName
          this.itemForm.name = nameWithoutExt
        }
        
        this.$cos.upload([file], {
          onSuccess: (files) => {
            if(files && files.length > 0){
              this.itemForm.content = files[0].url
              // 如果还没有设置名称，使用文件名
              if(!this.itemForm.name && fileName){
                const nameWithoutExt = fileName.substring(0, fileName.lastIndexOf('.')) || fileName
                this.itemForm.name = nameWithoutExt
              }
              this.$Message.success('文件上传成功')
            }
          },
          onFail: (err) => {
            this.$Message.error('文件上传失败: ' + err)
          }
        }, {
          coskey: this.$store.getters['session/session'].coskey
        })
        return false
      },
      handleItemOpen(item){
        this.current = item
        this.showDetail = true
      },
      handleItemEdit(item){
        this.itemForm = {
          id:item.id,
          type:item.type,
          content:item.content || '',
          dir_id:item.dir_id,
          name:item.name || ''
        }
        this.showItemEditor = true
      },
      handleSearch(){
        // 搜索逻辑已在computed中处理
      },
      handleToolbarInput(value){
        this.toolBarValue = value
        // 视图切换时更新 viewMode
        if(value && value.toolBarValue && value.toolBarValue.view_mode){
          // viewMode 会通过 computed 自动更新
        }
      },
      getItemIcon(item){
        // 如果是文件类型，根据文件扩展名返回不同图标
        if(item.type === 'file' && item.content){
          const url = item.content
          const fileName = url.split('/').pop() || ''
          const ext = fileName.split('.').pop().toLowerCase()
          return this.getFileIconByExt(ext)
        }
        
        // 其他类型使用固定图标
        const iconMap = {
          text: 'md-document',
          md: 'codelibrary-fill',
          html: 'css',
          ref: 'lianjie',
        }
        return iconMap[item.type] || 'wenjian'
      },
      getFileIconByExt(ext){
        const extIconMap = {
          'txt': 'md-document-text',
          'doc': 'md-document',
          'docx': 'md-document',
          'pdf': 'md-document',
          'xls': 'md-document',
          'xlsx': 'md-document',
          'ppt': 'md-document',
          'pptx': 'md-document',
          'js': 'codelibrary-fill',
          'ts': 'codelibrary-fill',
          'jsx': 'codelibrary-fill',
          'tsx': 'codelibrary-fill',
          'vue': 'codelibrary-fill',
          'py': 'codelibrary-fill',
          'java': 'codelibrary-fill',
          'cpp': 'codelibrary-fill',
          'c': 'codelibrary-fill',
          'go': 'codelibrary-fill',
          'php': 'codelibrary-fill',
          'rb': 'codelibrary-fill',
          'md': 'codelibrary-fill',
          'html': 'css',
          'htm': 'css',
          'xml': 'css',
          'json': 'codelibrary-fill',
          'yaml': 'codelibrary-fill',
          'yml': 'codelibrary-fill',
          'jpg': 'images',
          'jpeg': 'images',
          'png': 'images',
          'gif': 'images',
          'svg': 'images',
          'webp': 'images',
          'bmp': 'images',
          'zip': 'wenjian',
          'rar': 'wenjian',
          '7z': 'wenjian',
          'tar': 'wenjian',
          'gz': 'wenjian',
          'mp4': 'shipin',
          'avi': 'shipin',
          'mov': 'shipin',
          'mp3': 'shipin',
          'wav': 'shipin',
        }
        return extIconMap[ext] || 'wenjian'
      },
      getItemName(item){
        if(item.type === 'file' && item.content){
          const url = item.content
          const fileName = url.split('/').pop() || '未命名文件'
          return fileName
        }
        if(item.type === 'text' || item.type === 'md' || item.type === 'html'){
          const content = item.content || ''
          const firstLine = content.split('\n')[0] || '未命名文档'
          return firstLine.substring(0, 30) + (firstLine.length > 30 ? '...' : '')
        }
        return '未命名'
      },
    }
}
</script>

<style lang="less" scoped>
.knowledge-modal-content {
  padding: 20px;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}

.knowledge-modal-footer {
  padding: 15px 20px;
  border-top: 1px solid var(--border);
  display: flex;
  justify-content: flex-end;
  background: var(--bg3);
}

.markdown-editor-wrapper {
  position: relative;
  z-index: 1;
  
  /deep/ .v-note-wrapper {
    min-height: 500px;
    z-index: 1;
  }
  
  /deep/ .v-note-toolbar {
    z-index: 1000 !important;
    position: relative;
  }
  
  /deep/ .v-note-edit {
    min-height: 400px;
  }
}

.html-editor-wrapper {
  position: relative;
  min-height: 500px;
  
  /deep/ .tox-tinymce {
    min-height: 500px;
  }
  
  /deep/ .tox-edit-area {
    min-height: 450px;
  }
}

.type-selector {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.type-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px 20px;
  border: 2px solid var(--border);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  min-width: 100px;
  background: var(--bg3);
  
  &:hover {
    border-color: var(--primary);
    background: var(--primary-light);
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  
  &.active {
    border-color: var(--primary);
    background: var(--primary);
    color: #fff;
    box-shadow: 0 4px 12px rgba(51, 153, 255, 0.3);
  }
  
  span {
    margin-top: 8px;
    font-size: 14px;
    font-weight: 500;
  }
}

.dir-type-selector {
  display: flex;
  gap: 10px;
  
  .dir-type-option {
    display: flex;
    align-items: center;
    padding: 10px 20px;
    border: 2px solid var(--border);
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s;
    background: var(--bg3);
    
    &:hover {
      border-color: var(--primary);
      background: var(--primary-light);
    }
    
    /deep/ .ivu-radio-wrapper {
      display: flex;
      align-items: center;
      margin: 0;
      
      .ivu-radio {
        margin-right: 8px;
      }
    }
    
    /deep/ .ivu-radio-wrapper-checked {
      border-color: var(--primary);
      background: var(--primary);
      color: #fff;
    }
  }
}

</style>